import { View } from "@/enums/view";
import { getObjectFromLocalStorage, setObjectInLocalStorage } from "@/helpers/localStorage";

type LastUserView = {
  view: View;
  organizationId?: string;
};

const getLastUserViews = (): Record<string, LastUserView> | undefined => {
  return getObjectFromLocalStorage?.<Record<string, LastUserView>>("lastUserViews");
};

export const getLastUserView = (userId?: string): LastUserView | undefined => {
  if (!userId) {
    return undefined;
  }
  const lastUserViews = getLastUserViews();
  return lastUserViews?.[userId];
};

export const setLastUserView = (userId: string, view: View, organizationId?: string) => {
  if (userId) {
    const lastUserViews = getLastUserViews();
    setObjectInLocalStorage?.("lastUserViews", {
      ...lastUserViews,
      [userId]: { view, organizationId } as LastUserView,
    } as Record<string, LastUserView>);
  }
};
